import { useTheme } from '@/contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

export default function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      className="relative inline-flex h-8 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2"
      style={{
        backgroundColor: isDarkMode ? '#1e3a5f' : '#e5e7eb',
        border: isDarkMode ? '2px solid #60a5fa' : 'none',
        boxShadow: isDarkMode ? '0 0 10px rgba(96, 165, 250, 0.3)' : 'none'
      }}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span
        className="inline-flex h-6 w-6 transform items-center justify-center rounded-full shadow-lg transition-transform duration-300"
        style={{
          transform: isDarkMode ? 'translateX(26px)' : 'translateX(4px)',
          backgroundColor: isDarkMode ? '#fbbf24' : 'white'
        }}
      >
        {isDarkMode ? (
          <Moon className="h-4 w-4 text-[#1e3a5f]" />
        ) : (
          <Sun className="h-4 w-4 text-yellow-500" />
        )}
      </span>
    </button>
  );
}
